export default __webpack_public_path__ + "static/media/Calendar.49967849.svg";